import React, { Component } from "react";
import {
  addInteractiveMapName,
  openiMapModal,
  addMapWithName,
  updateMapWithName,
} from "InteractiveMapAction";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { connect } from "react-redux";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import { maxLengthObjectFc } from "Constants";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class BoothName extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  closeModal = () => {
    this.props.callback();
  };

  onFormSubmit(values) {
    let { session } = this.props;
    values.mapname = values.mapname.trim();
    if (this.props.toEdit) {
      this.props.updateMapWithName(
        {
          ...values,
          interactivemapid: this.props.selectedMap.interactivemapid,
          eventid: session.eventid,
        },
        this.props.session,
        () => {
          this.props.callback();
        }
      );
    } else {
      this.props.addMapWithName(values, this.props.session);
      this.props.checkContentDashboardStatus(this.props.session);
    }
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
        className="animated fadeIn"
      >
        <div className="mapname-container">
          <div className="mapname-backdrop"></div>
          <div className="mapname-header">
            <button
              type="button"
              className="i-custom-cross-popup pull-right mr-20 mt-minus2"
              style={{ marginRight: 20, marginTop: -2 }}
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
              {/* <span aria-hidden="true">&times;</span> */}
            </button>
          </div>
          <div className="mapname-box">
            <Field
              name="mapname"
              label={LocaleStrings.map_label_mapname}
              placeholder={LocaleStrings.map_placeholder_mapname}
              type="text"
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
              component={this.renderFieldText}
              maxlength={MAXLENOBJ.mapname ? MAXLENOBJ.mapname : ""}
            />
            <Button
              className="btn btn-custom-blue"
              disabled={pristine || invalid || submitting}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

function validate(values) {
  var maxLengthFields = ["mapname"];
  var errors = {};
  if (!values.mapname || values.mapname.trim() === "") {
    errors.mapname = LocaleStrings.map_validation_mapname;
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function mapStateToProps(state) {
  var initialValues = {};

  if (state.selectediMap) {
    initialValues = { mapname: state.selectediMap.mapname };
  } /*else if(state.addMapName){
    initialValues={mapname:state.addMapName.payload};
  }*/
  return {
    session: state.session,
    mapname: state.selectediMap.mapname,
    selectedMap: state.selectediMap,
    initialValues,
  };
}

export default connect(mapStateToProps, {
  addInteractiveMapName,
  openiMapModal,
  updateMapWithName,
  addMapWithName,
  checkContentDashboardStatus,
})(
  reduxForm({
    form: "AddMapName",
    validate,
    enableReinitialize: true,
  })(BoothName)
);
